import { mutateGraphQL } from '~/hooks/graphql.js';

const checkAffiliateRefMutation = `
  mutation CheckAffiliateRef ( $refToken: String! ) {
    checkAffiliateRef(input: { ref: $refToken }) {
      status
    }
  }
`;

/**
 * Check the user's affiliate ref and if valid set affiliate cookie for client
 */
export function checkAffiliateRefMutationHandler ({ refToken }) {
  const { mutationHandler } = mutateGraphQL(checkAffiliateRefMutation);

  return mutationHandler({ refToken });
}
